import * as style from "@COMPONENTS/style/partners/styles";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Flex} from "@FRAMEWORK/ui/desktop/layout";

const Header = () => (
	<style.Header>
		<h2>국내여행</h2>
		<Flex gap="30">
			<style.ConfirmButton
				href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/accounts/partnersReserveAuth.yb?channelCode=prdt001`}
				target="_blank"
			>
				예약확인
			</style.ConfirmButton>
			<style.Logo href={"#"}>
				<img src={"/include/images/common/logo_yb.png"} alt="노랑풍선" width="155" height="42"></img>
			</style.Logo>
		</Flex>
	</style.Header>
);

export default Header;
